import { doc, setDoc } from "firebase/firestore";
import { db } from "@/lib/firebase";
import { httpsCallable, getFunctions } from "firebase/functions";
import { logger } from "@/lib/logger";

// Function to create a user record in Firestore after user is created in Auth
export const createUserRecord = async (
  userId: string,
  name: string,
  email: string,
  role: string,
  position?: string
) => {
  try {
    await setDoc(doc(db, "users", userId), {
      name,
      email,
      role,
      position: position || "",
      active: true, // Sicherstellen, dass neue Nutzer aktiv sind
      createdAt: new Date().toISOString()
    });
    return true;
  } catch (error) {
    logger.error("Error creating user record:", error);
    throw error;
  }
};

// This function would normally call a Firebase Cloud Function
// Since we don't have one set up, we'll use the REST API
export const createUserWithoutSignIn = async (
  email: string,
  password: string,
  name: string,
  role: string,
  position?: string
) => {
  try {
    // Create a temporary form data to simulate a POST request to Firebase Auth REST API
    // This is a simplified version and would normally be done server-side
    const apiKey = "AIzaSyB8gDtFV9vqRbpZfE7TiUQQHjqVREiW2K8"; // This is publicly visible in the Firebase config
    const url = `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${apiKey}`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        password,
        returnSecureToken: false
      })
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error?.message || "Error creating user");
    }
    
    // Now create the user record in Firestore
    const userId = data.localId;
    await createUserRecord(userId, name, email, role, position);
    
    return { success: true, userId };
  } catch (error) {
    console.error("Error creating user:", error);
    throw error;
  }
}; 
 